// extracted by mini-css-extract-plugin
module.exports = {"container":"JobToBeDone_container__1etnk","title":"JobToBeDone_title__3s4DD","jobsContainer":"JobToBeDone_jobsContainer__1v_8b"};